/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dusty_Gray_Dog_GripInputs */

const en_dusty_gray_dog_grip = /** @type {(inputs: Dusty_Gray_Dog_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Users`)
};

const de_dusty_gray_dog_grip = /** @type {(inputs: Dusty_Gray_Dog_GripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer exportieren`)
};

/**
* | output |
* | --- |
* | "Export Users" |
*
* @param {Dusty_Gray_Dog_GripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dusty_gray_dog_grip = /** @type {((inputs?: Dusty_Gray_Dog_GripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dusty_Gray_Dog_GripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dusty_gray_dog_grip(inputs)
	return de_dusty_gray_dog_grip(inputs)
});